export default __webpack_public_path__ + "static/media/15t.1e92a195.jpg";